/*eslint-disable */
import {bus} from '@/main';
export default {
  name: 'payment-confirmation-of-popup',
  components: {},
  props: [],
  data () {
    return {
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    blurbTextPopupClosed(){
      bus.$emit('paymentConfirmationPopupStateBus', false);
      document.body.classList.remove('body_right_scroll_remove')
    }
  }
}